import React from 'react';
import FooterOne from '../../common/footer/FooterOne';
import HeaderOne from '../../common/header/HeaderOne';
import BcrumbBannerOne from '../../elements/breadcrumb/BcrumbBannerOne';
import SectionTitle from '../../elements/section-title/SectionTitle';
import AboutTwo from '../../component/about/AboutTwo_EnergieRenouvelable';
import ColorSwitcher from '../../elements/switcher/ColorSwitcher';
import SEO from '../../common/SEO';
import Tilty from 'react-tilty';
import { useTranslation } from 'react-i18next';
import OutrosServicos from '../OutrosServicos';
import ShapeBubble from '../../component/shapes/ShapeBubble';

const ServiceDetails = () => {

    const { t } = useTranslation();

    return (
        <>
            <SEO title={t('Service Maintenance')} />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BcrumbBannerOne
                    title={t('Maintenance')}
                    paragraph={t('texto_sobre_maintenance')}
                    tituloabranco="yes"
                    mainThumb="/images/services/EnergieRenouvelable/maintenance.webp"
                />
                <AboutTwo></AboutTwo>
                <div className="section section-padding bg-color-light pb--70" id="sectionbaixo">

                    <div className="container">
                        <div className='row'>
                            <div className="col-lg-6 col-md-12 process-work">
                                <Tilty className="tilty-container" perspective={2000} style={{ width: '100%' }}>
                                    <div className="thumbnail_custom">
                                        <img
                                            src="/images/services/EnergieRenouvelable/maintenance/detalhe1.webp"
                                            alt="Thumbnail"
                                            style={{ borderRadius: "10px", width: "610px", height: "460px", objectFit: "cover" }}
                                        />
                                    </div>
                                </Tilty>
                            </div>
                            <div className="col-lg-6 col-md-12 content">
                                <p className="h3 title">{t('Comment ça fonctionne')}</p>
                                <p>{t('maintenance_quote1')}</p><br />
                                <div dangerouslySetInnerHTML={{ __html: t('maintenance_list') }} />
                            </div>
                        </div>
                    </div>

                    <ul className="shape-group-17 list-unstyled">
                        {/* <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-24.png"} alt="Bubble" /></li> */}
                        <ShapeBubble />
                        <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/line-4.webp"} alt="Line" /></li>
                        <li className="shape shape-4"><img src={process.env.PUBLIC_URL + "/images/others/line-5.webp"} alt="Line" /></li>
                        <li className="shape shape-5"><img src={process.env.PUBLIC_URL + "/images/others/line-4.webp"} alt="Line" /></li>
                        <li className="shape shape-6"><img src={process.env.PUBLIC_URL + "/images/others/line-5.webp"} alt="Line" /></li>
                    </ul>
                </div>
                <div className="section section-padding">
                    <div className="container">
                        <SectionTitle
                            title={t("Nos autres services")}
                            description=""
                            textAlignment=""
                            textColor=""
                        />
                        <OutrosServicos></OutrosServicos>
                    </div>
                    <ul className="shape-group-16 list-unstyled">
                        <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/circle-2.webp"} alt="circle" /></li>
                        <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.webp"} alt="Line" /></li>
                    </ul>
                </div>
                <FooterOne parentClass="" />
            </main >
        </>
    )
}

export default ServiceDetails;